"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logSourceChanges = logSourceChanges;
var _StudioLogger = require("@studio/logger/StudioLogger");
var LOG = new _StudioLogger.StudioLogger('sourcesAuditLogger');

/**
 * Logs differences between old and new source states for debugging and audit purposes.
 *
 * @param {Array} oldSources - Previous sources from reducer state
 * @param {Array} newSources - New sources from action payload
 * @param {string} actionType - The action type triggering the change
 */
function logSourceChanges() {
  var oldSources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newSources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var actionType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'BROADCAST_GET_SOURCES_SUCCESS';
  if (!Array.isArray(oldSources) || !Array.isArray(newSources)) {
    LOG.warn('Invalid source arrays provided to logSourceChanges', {
      oldSources: oldSources || null,
      newSources: newSources || []
    });
    return;
  }
  var oldSourcesPick = oldSources.map(function (s) {
    return {
      _id: s._id,
      type: s.type,
      title: s.title,
      value: s.value
    };
  });
  var newSourcesPick = newSources.map(function (s) {
    return {
      _id: s._id,
      type: s.type,
      title: s.title,
      value: s.value
    };
  });
  var hasChanges = oldSourcesPick.length !== newSourcesPick.length || oldSourcesPick.some(function (oldSource, index) {
    var newSource = newSourcesPick[index];
    if (!newSource) {
      return true;
    }
    return oldSource._id !== newSource._id || oldSource.type !== newSource.type || oldSource.title !== newSource.title || oldSource.value !== newSource.value;
  });
  if (!hasChanges) {
    LOG.debug("No source changes detected [".concat(actionType, "]"));
    return;
  }
  LOG.info("Comparing old and new sources for changes [".concat(actionType, "]"), {
    oldSources: oldSourcesPick,
    newSources: newSourcesPick
  });
}